import { KykkaState } from "../Constants/KykaState";
import KykkaSizeConstants from "../Constants/KykkaSizeConstants";
import { Point } from "../Math/Point";

export class KykkaModel {
    public x: number = 0;
    public y: number = 0;
    public z: number = 0;

    public rotationX: number = 0;
    public rotationY: number = 0;
    public rotationZ: number = 0;

    public state: KykkaState = KykkaState.InCity;

    public isActive: boolean = false;

    constructor(x: number, y: number, z:number) {
        this.x = x;
        this.y = y;
        this.z = z;
    }

    get isStanding() {
        const { rotationX, rotationY, rotationZ} = this;
        const delta = 1;
        return Math.abs(rotationX) < delta && Math.abs(rotationY) < delta && Math.abs(rotationZ) < delta;
    }

    // Return point in 2D axis
    get leftMost(): Point {
        return this._findMostPoint('x', 'min');
    }

    // Return point in 2D axis
    get rightMost(): Point {
        return this._findMostPoint('x', 'max');
    }

    // Return point in 2D axis
    get topMost(): Point {
        return this._findMostPoint('y', 'min');
    }

    // Return point in 2D axis
    get bottomMost(): Point {
        return this._findMostPoint('y', 'max');
    }

    get rectPoints(): Point[] {

        const { height, diameter } = KykkaSizeConstants;
        const { x, z } = this;

        // if(this.isStanding) {
            return [
                new Point(x - 0.5 * diameter, z - 0.5 * diameter),
                new Point(x + 0.5 * diameter, z - 0.5 * diameter),
                new Point(x - 0.5 * diameter, z + 0.5 * diameter),
                new Point(x + 0.5 * diameter, z + 0.5 * diameter)
            ]
        // }

        // const x1 = x - 0.5 * diameter * Math.cos(this.rotationY) + 0.5 * height * Math.sin(this.rotationY);
        // const y1 = z - 0.5 * diameter * Math.sin(this.rotationY) + 0.5 * height * Math.cos(this.rotationY);

        // const x2 = x + 0.5 * diameter * Math.cos(this.rotationY) + 0.5 * height * Math.sin(this.rotationY);
        // const y2 = z + 0.5 * diameter * Math.sin(this.rotationY) + 0.5 * height * Math.cos(this.rotationY);

        // const x3 = x + 0.5 * diameter * Math.cos(this.rotationY) - 0.5 * height * Math.sin(this.rotationY);
        // const y3 = z + 0.5 * diameter * Math.sin(this.rotationY) - 0.5 * height * Math.cos(this.rotationY);

        // const x4 = x - 0.5 * diameter * Math.cos(this.rotationY) - 0.5 * height * Math.sin(this.rotationY);
        // const y4 = z - 0.5 * diameter * Math.sin(this.rotationY) - 0.5 * height * Math.cos(this.rotationY);

        // return [
        //     new Point(x1, y1),
        //     new Point(x2, y2),
        //     new Point(x3, y3),
        //     new Point(x4, y4)
        // ];
    }

    private _findMostPoint(prop: string, direction: string): Point {
        const points = this.rectPoints;
        let targetIndex = 0;
        let target = points[targetIndex];
        for (let index = 1; index < points.length; index++) {
            if (direction === 'min' && points[index][prop] < target[prop]
                || direction === 'max' && points[index][prop] > target[prop]) {
                targetIndex = index
                target = points[targetIndex];
            }
        }
        return target;
    }


}